module.exports = __webpack_public_path__ + "img/pattern1.b284947.svg";